import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import StateContext from '../context/State';
import PortalService from '../services/portal.service';
import { ClientInfoModel } from '../types';

/**
 * Custom hook to fetch client information for a portal
 * @param enabled - Whether the query should run (typically based on modal visibility)
 * @returns Query result with client information data, loading state, and error
 */
export function useClientInformation(enabled = true) {
    const { state } = useContext(StateContext);
    const portalService = new PortalService(state);
    
    return useQuery<ClientInfoModel[]>({
        queryKey: ['clientInformation', state.portalId],
        queryFn: async () => {
            const clientInfo = await portalService.getClientInformation(state.portalId);
            return clientInfo || [];
        },
        enabled: enabled && Boolean(state.portalId), // Only fetch when enabled and we have a valid portalId
        staleTime: 0,          // Always consider stale (refetch when modal opens)
        refetchOnMount: true,  // Refetch each time the component mounts
    });
}

